import { Link } from "react-router-dom";
import { routerPaths } from "../services/path";

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center bg-gray-100">
      <h2 className="text-6xl font-bold text-red-500">404 - Page Not Found</h2>
      <p className="p-4 text-lg text-gray-700">
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </p>
      <Link
        to={routerPaths.dashboard}
        className="mt-8 px-4 py-2 font-semibold text-white bg-primary rounded hover:bg-red-400"
      >
        Go to Home Page
      </Link>
    </div>
  );
}

export default NotFoundPage;
